﻿/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo dialog
--------------------------------------------------------------------------------

2017-01-12 --> Alan
Change is close button will apply to dialog only. So if you want/need to use some predefined dialogs (alert, prompt, confirm) you need to extend them too.
Title false will not work from backend helper. This bug is submitted to Kendo and we are waiting resolution. 

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Dialog = kendo.ui.Dialog;
    if (!Dialog || Dialog.updated) return;
    var proxy = $.proxy;
    var HUNDREDPERCENT = 100;

    var templates = {
        action: kendo.template("<button type='button' class='k-button# if (data.primary) { # k-primary# } role='button' #'></button>"),
        titlebar: kendo.template('<div class=\'k-window-titlebar k-dialog-titlebar k-header\'>' + '<span class=\'k-window-title k-dialog-title\'>#: title #</span>' + '<div class=\'k-window-actions k-dialog-actions\' />' + '</div>'),
        close: kendo.template('<a role=\'button\' href=\'\\#\' class=\'k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close\' title=\'#: messages.close #\' aria-label=\'#: messages.close #\' tabindex=\'-1\'><span class=\'k-icon k-i-close\'></span></a>'),
    };

    function createDialog() {
        var that = this, content = that.element, options = that.options, isRtl = kendo.support.isRtl(content), titlebar = $(templates.titlebar(options)), titlebarActions = titlebar.find('.k-window-actions'), titleId = (content.id || kendo.guid()) + '_title', wrapper = $(that.wrapperTemplate(options));
        wrapper.toggleClass('k-rtl', isRtl);
        content.addClass("k-content");
        that.appendTo.append(wrapper);
        if (options.closable !== false) {
            if (options.title !== false) {
                titlebarActions.append(templates.close(options));
            } else {
                wrapper.append(templates.close(options));
            }
        }
        if (options.title !== false) {
            wrapper.append(titlebar);
            titlebar.attr('id', titleId);
            wrapper.attr('aria-labelledby', titleId);
        } else {
            wrapper.addClass("k-dialog-titleless");
        }
        wrapper.append(content);
        if (options.content) {
            kendo.destroy(content.children());
            content.html(options.content);
        }
        if (options.actions.length) {
            that._createActionbar(wrapper);
        }
    }

    function addButtons(actionbar) {
        var that = this,
            o = that.options,
            actionClick = proxy(that._actionClick, that),
            actionKeyHandler = proxy(that._actionKeyHandler, that),
            actions = that.options.actions,
            length = actions.length,
            buttonSize = Math.round(HUNDREDPERCENT / length),
            action,
            text;

        for (var i = 0; i < length; i++) {
            action = actions[i];
            text = that._mergeTextWithOptions(action);
            var btn = $(templates.action(action))
                .autoApplyNS(".kendoButton")
                .html(text)
                .appendTo(actionbar)
                .data("action", action.action)
                .on("click", actionClick)
                .on("keydown", actionKeyHandler);
        }
    }

    Dialog = Dialog.extend({
        // new init
        init: kendo.getGenericInit(Dialog),
        _createDialog: createDialog,
        _addButtons: addButtons
    });

    Dialog.updated = true;

    kendo.ui.plugin(Dialog);

})(window.kendo.jQuery);
